import {
    Grid,
    GridItem,
} from '@chakra-ui/react'
import Comment from './Comment';

const Comments = () => {
    return (
        <Grid
            // Show 6 comments in 2 rows
            templateColumns={{
                base: 'repeat(1, 1fr)',
                md: 'repeat(2, 1fr)',
            }}
            gap={6}
            w='100%'
            flexDir='column'
        >
            <GridItem>
                <Comment
                    comment={{
                        name: 'John Doe',
                        comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                        rating: 5,
                    }}
                />
            </GridItem>
            <GridItem>
                <Comment
                    comment={{
                        name: 'John Doe',
                        comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                        rating: 5,
                    }}
                />
            </GridItem>
            <GridItem>
                <Comment
                    comment={{
                        name: 'John Doe',
                        comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                        rating: 5,
                    }}
                />
            </GridItem>
            <GridItem>
                <Comment
                    comment={{
                        name: 'John Doe',
                        comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                        rating: 5,
                    }}
                />
            </GridItem>
            <GridItem>
                <Comment
                    comment={{
                        name: 'John Doe',
                        comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                        rating: 5,
                    }}
                />
            </GridItem>
            <GridItem>
                <Comment
                    comment={{
                        name: 'John Doe',
                        comment: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.',
                        rating: 5,
                    }}
                />
            </GridItem>
        </Grid>
    )
}

export default Comments;